import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Button } from '@material-ui/core/'
import { withStyles } from '@material-ui/core/styles'

import SpinnerImage from '../../../../assets/images/icons/spinning-circles.svg'

class SpinnerSubmitButton extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    children: PropTypes.node.isRequired,
    isSubmitting: PropTypes.bool.isRequired,
  }

  static styles = (theme) => ({
    buttonContained: theme.buttonContained,
    buttonClicked: {
      '&:disabled': {
        background: '#000',
      },
    },
    buttonSpinner: {
      position: 'absolute',
      top: 0,
      height: '100%',
      width: '100%',
      background: '#000',
      padding: theme.spacing(1),
      '& img': {
        margin: 0,
        height: '100%',
      },
    },
  })

  render() {
    const {
      classes,
      children,
      isSubmitting,
      ...buttonProps
    } = this.props

    const props = {
      ...buttonProps,
      variant: 'contained',
    }

    let buttonClassName = classes.buttonContained
    if (isSubmitting) {
      buttonClassName = classNames(buttonClassName, classes.buttonClicked)
    }

    return (
      <Button
        classes={{ contained: buttonClassName }}
        {...props}
      >
        { children }
        {isSubmitting && (
          <div className={classes.buttonSpinner}>
            <img src={SpinnerImage} alt="Loading..." />
          </div>
        )}
      </Button>
    )
  }
}

export default withStyles(SpinnerSubmitButton.styles)(SpinnerSubmitButton)
